// @ts-nocheck - legacy JS, bỏ dòng này khi migrate sang TS
import SelectBox from '../ui/editors/SelectBox';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { namHocAPi } from '../../api/namHocApi';
import { useCommonContext } from '../../contexts/common';
import { pageBaseStatus } from '../../state/pageBaseStatus';
import { namHocActionTypes } from '../../state/reducers/namHocReducer';

const ComboboxNamHoc = ({ value, onValueChanged, cmb, width }: any) => {
  const { translate } = useCommonContext();
  const { nam_hocs, status } = useSelector(x => x.namHoc)
  const dispatch = useDispatch();
  useEffect(() => {
    if (status == pageBaseStatus.is_not_initial) {
      handleReload();
    }
  }, [status]);
  const handleReload = async () => {
    const res = await namHocAPi.SelectAll();
    if (res.is_success) {
      dispatch({ type: namHocActionTypes.LOAD.SUCESS, payload: res.data })
    }
  };
  return (
    <SelectBox
      dataSource={nam_hocs}
      displayExpr={'nam_hoc'}
      valueExpr={'nam_hoc'}
      placeholder={translate('Chọn năm học')}
      value={value}
      stylingMode="outlined"
      width={width || 120}
      ref={cmb}
      onValueChanged={(e) => {
        if (e.event) onValueChanged(e.value);
      }}
    />
  );
};

export default ComboboxNamHoc;
